import { Injectable } from '@angular/core';

import { FoodModel } from '../../models/models';
import { ApiProvider } from '../api/api';

@Injectable()
export class FoodProvider {
  private items: FoodModel[] = [];

  constructor(
    private api: ApiProvider) {
  }

  Add(item: FoodModel) {
    this.items.push(item);
  }

  Exists(item: FoodModel): boolean {
    return this.items.find(x => {
      return x._id !== item._id && x.Name === item.Name && x.Brand === item.Brand;
    }) !== undefined;
  }

  Get(id) {
    return this.items.filter(x => x._id === id)[0];
  }

  List(): FoodModel[] {
    return this.items;
  }

  Load(force: boolean = false) {
    return new Promise((resolve, reject) => {
      if (this.items.length === 0 || force) {
        this.LoadFromApi().then((data: FoodModel[]) => {
          this.items = data;
          resolve(this.items);
        });
      }
      else {
        resolve(this.items);
      }
    });
  }

  Remove(item: FoodModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`food/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(item: FoodModel) {
    return new Promise((resolve, reject) => {
      const isNew = item._id === undefined;

      item._id = item._id || null;

      this.api.post('food/', item).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          item._id = data.id;

          if (isNew) {
            // add the item to the list
            this.items.push(item);
          }

          resolve(item);
        }
      });
    });
  }

  Sort(items: any = undefined) {
    if (!items) {
      items = this.items;
    }
    items.sort((a, b) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });
    return items;
  }

  private LoadFromApi() {
    return new Promise((resolve, reject) => {
      this.api.get('food/').subscribe((data) => {

        const arr = data.json();

        let obj: FoodModel[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            Name: item.name,
            Brand: item.brand,
            Portion: item.portion,
            ServingSize: Number(item.serving_size),
            Serving: 1,
            Notes: item.notes,
            Nutrition: {
              Calories: Number(item.calories),
              Fat: Number(item.fat),
              Carbohydrates: Number(item.carbohydrates),
              Protein: Number(item.protein)
            }
          });          
        }

        resolve(obj);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/food/food.ts